import StudioModal from '@/components/modals/StudioModal.vue';
import CheckoutMixin from './CheckoutMixin';
import { Component, Mixins } from 'vue-property-decorator';
import { EModalName } from '@/helpers/modal';
import { Button } from 'streamlabs-beaker';
import Checkout from './Checkout.vue';
import { ESubscriptionPlanType, ESubscriptionStep } from '@/helpers/subscription';
import { EAnalyticsEvent } from '@/helpers/analytic';

@Component({
  components: {
    StudioModal,
    SButton: Button,
    Checkout,
  },
})
export default class CheckoutModalMini extends Mixins(CheckoutMixin) {
  step: ESubscriptionStep = ESubscriptionStep.choosePlan;

  get modalName(): string {
    return EModalName.checkoutMini;
  }

  async beforeOpen({ params }) {
    if (params?.step) this.step = params.step;
    if (!this.selectedPlan) this.selectedPlan = ESubscriptionPlanType.annual;

    this.$sla.sendEvent(this.isFreeTrial ? EAnalyticsEvent.checkoutImpressionFreeTrial : EAnalyticsEvent.checkoutImpression, { freeTrial: this.isFreeTrial });
  }

  hideModal() {
    this.step = ESubscriptionStep.choosePlan;
    this.$modal.hide(this.modalName);
  }

  async modalProcessOrder(braintreePayload) {
    await this.processOrder(braintreePayload);

    this.hideModal();
    if (this.$route.path !== '/projects') this.$router.push('/projects');
  }
}
